// extracted by mini-css-extract-plugin
export default {"header":"_CLv5I","content":"DuchNt","primaryBtnBottomFixed":"mPcjhw","secondaryBtn":"JrAYrV","container":"qNa68M"};